import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Shared mobile/desktop sidebar open state so the header can host the
 * menu toggle next to the logo without coupling the two components.
 */
@Injectable({
	providedIn: 'root',
})
export class SidebarUiService {
	private readonly _collapsed$ = new BehaviorSubject<boolean>(false);
	readonly collapsed$ = this._collapsed$.asObservable();

	get isCollapsed(): boolean {
		return this._collapsed$.value;
	}

	setCollapsed(collapsed: boolean) {
		if (this._collapsed$.value === collapsed) return;
		this._collapsed$.next(collapsed);
	}

	toggle() {
		this._collapsed$.next(!this._collapsed$.value);
	}

	open() {
		this.setCollapsed(false);
	}

	close() {
		this.setCollapsed(true);
	}
}
